import { memo } from "react";
import PropTypes from "prop-types";
import MoreDetails from "app/pages/.shared/MoreDetails";
import { FormattedMessage } from "react-intl";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import Amenity from "app/pages/FicheProduit/components/Amenities/Amenity";

import "./Amenities.scss";

const Amenities = ({ headline, amenities = [] }) => {
	if (amenities.length === 0) {
		return false;
	}

	return (
		<div className="amenities-sections">
			{headline && (
				<Typography
					variant={TYPOGRAPHY_VARIANTS.XL4}
					isBold
					className="amenities-sections__title"
					data-testid="amenities-sections-title"
					component="h2"
				>
					{headline}
				</Typography>
			)}
			<div>
				{amenities.slice(0, 3)?.map(({ headline, names }) => (
					<Amenity {...{ headline, names }} />
				))}
			</div>
			{amenities.length > 3 && (
				<div className="amenities-sections__details">
					<MoreDetails
						expandedLabel={<FormattedMessage id="product.page.less.services" />}
						collapsedLabel={<FormattedMessage id="product.page.more.services" />}
					>
						{amenities.slice(3, amenities.length)?.map(({ headline, names }) => (
							<Amenity {...{ headline, names }} />
						))}
					</MoreDetails>
				</div>
			)}
		</div>
	);
};

Amenities.propTypes = {
	headline: PropTypes.string.isRequired,
	amenities: PropTypes.arrayOf(
		PropTypes.shape({
			headline: PropTypes.string,
			names: PropTypes.arrayOf(PropTypes.string),
		})
	),
};

export default memo(Amenities);
